import styles from './ReportTable.module.scss';
import React from 'react';

export interface ReportTableProps {
  width?: number;
  height?: number;
  columns: string[];
  rows: {
    label: string;
    values: string[];
  }[];
  leftPadding?: boolean;
  title?: string;
  isHighlight?: boolean;
  highlightRowIndex?: number;
  isFixedColor?: boolean;
  className?: string;
}

const ReportTable: React.FC<ReportTableProps> = ({
  columns,
  rows,
  leftPadding,
  title,
  highlightRowIndex,
  className,
}) => {
  const tableClass = className ? styles[className] : undefined;
  const tbodyClass = styles[`tbody${columns.length}` as keyof typeof styles];

  return (
    <table className={tableClass}>
      <thead className={styles.thead}>
        {!!title && (
          <tr>
            <td>{title}</td>
          </tr>
        )}
      </thead>
      <tbody className={tbodyClass}>
        <tr>
          {leftPadding && <th />}
          {columns.map((col, idx) => (
            <th key={idx}>{col}</th>
          ))}
        </tr>
        {rows.map(({ label, values }, index) => {
          const highlightClass =
            highlightRowIndex === index ? styles['highlight-row'] : undefined;
          return (
            <tr className={highlightClass} key={index}>
              <td>{label}</td>
              {values.map((value, index2) => (
                <td key={index2}>{value}</td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ReportTable;
